export default __webpack_public_path__ + "static/impersonator-scam-alert-2-210a4c929a9a1b64d111f0c401450d57.webp";